<template>
  <div class="reports-sidebar-container scroll-fire-fox">
    <home-accordion
      v-for="menuItem in menuItemsAvailable"
      :key="menuItem.name"
      :label="menuItem.name"
    >
      <template v-slot:accordionBodyContent>
        <sidebar-button
          v-for="submenuItem in menuItem.submenu"
          :key="submenuItem.name"
          v-if="isSuperAdmin || !submenuItem.dev"
          :item="submenuItem"
          :selected="selected"
          @toggle="toggleSelected"
        />
      </template>
    </home-accordion>
  </div>
</template>

<script>
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import SidebarButton from "./ReportsSidebarButton";
import HomeAccordion from "../../../HomeAccordion";

export default {
  components: {
    HomeAccordion,
    SidebarButton
  },

  mixins: [checkPermissionsMixin],

  props: ["menuItems"],

  data() {
    return {
      selected: undefined
    };
  },

  computed: {
    menuItemsAvailable() {
      let items = [];
      this.menuItems.forEach(menuItem => {
        if (menuItem.submenu.length !== 0) {
          items.push(menuItem);
        }
      });
      return items;
    }
  },

  methods: {
    toggleSelected(item) {
      this.selected = item;
      this.$emit("toggle", this.selected);
    }
  }
};
</script>

<style scoped>
.reports-sidebar-container {
  width: 300px;
  height: fit-content;
  max-height: 100%;
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.07);
  display: flex;
  flex-direction: column;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/Sidebar/ReportsSidebar.vue